import { render, staticRenderFns } from "./raw.vue?vue&type=template&id=23ba25f6"
import script from "./raw.vue?vue&type=script&lang=js"
export * from "./raw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports